import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
import LinkHandler from '../link-handler';
import { buttonStyles } from '../styled/buttons';
import { getIconPadding, getIconSize } from '../styled/buttons-factory';
import { h3, h4 } from '../styled/typography';

export const IconHolder = styled(SVG)`
  width: ${({ theme, $size }) => getIconSize({ theme, $size })};
  height: ${({ theme, $size }) => getIconSize({ theme, $size })};
  display: inline-block;
  margin-top: -2px;
`;

export const TextElement = styled.span`
  display: inline-block;

  ${({ $size }) =>
    $size === 'xxl' &&
    css`
      ${h3}
    `};

  ${({ $size }) =>
    $size === 'xl' &&
    css`
      ${h4}
    `};

  ${({ $size }) =>
    ($size === 'xxl' || $size === 'xl') &&
    `
      font-weight: bold;
      margin-top: 0;
      margin-bottom: 0;
  `}
`;

export const StyledLinkHandler = styled(LinkHandler)`
  ${buttonStyles};
  margin-bottom: ${({ $marginBottom, theme }) =>
    $marginBottom && theme.spacing.large};

  ${IconHolder} {
    ${({ $iconPlacement }) =>
      $iconPlacement === 'left' &&
      css`
        margin-right: ${(props) => getIconPadding(props)};
      `};

    ${({ $iconPlacement }) =>
      $iconPlacement === 'right' &&
      css`
        margin-left: ${(props) => getIconPadding(props)};
      `};
  }
`;
